import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { i18n, useTranslation } from '@lt/localization';
import { InstantConfirmFlat } from '@lt/components/icons-react/userflow';
import { components } from '@lt/components/components/MultiToggleSwitch/MultiToggleSwitch';

import MultiToggleFilterGroup from '../components/MultiToggleFilterGroup';

const FILTER_LABEL = i18n.t('filters.confirm.filter_label');

const FILTER_NAMES = {
  1: i18n.t('filters.confirm.instant.label'),
  2: i18n.t('filters.confirm.fast.label'),
  3: i18n.t('filters.confirm.all.label'),
};

const FilterConfirmability = ({
  data,
  className,
  onChange,
  isMobile,
  isHotelOnly,
  currencyCode,
}) => {
  const { t } = useTranslation();

  const tourType = isHotelOnly
    ? t('tourType.onlyHotel.plural')
    : t('tourType.withFlights.plural');

  const LABEL_LIST = useMemo(
    () => ({
      1: {
        LABEL: (
          <span>
            {t('filters.confirm.instant.label', {
              title: tourType,
            })}{' '}
            {isMobile ? <StyledLabelIcon /> : null}
          </span>
        ),
        TOOLTIP: t('filters.confirm.instant.tooltip', {
          context: isHotelOnly ? 'hotel' : 'package',
        }),
      },
      2: {
        LABEL: t('filters.confirm.fast.label'),
        TOOLTIP: t('filters.confirm.fast.tooltip', {
          title: tourType,
        }),
      },
      3: {
        LABEL: t('filters.confirm.all.label', {
          title: tourType,
        }),
        TOOLTIP: t('filters.confirm.all.tooltip', {
          context: isHotelOnly ? 'hotel' : 'package',
        }),
      },
    }),
    [tourType, isHotelOnly],
  );

  const switcherIcon = isMobile ? null : <StyledToggleIcon />;

  return (
    <StyledMultiToggleFilterGroup
      className={className}
      filterName="confirmability"
      filterLabel={FILTER_LABEL}
      switcherIcon={switcherIcon}
      labelIcon={isMobile ? undefined : <StyledLabelIcon />}
      onChange={onChange}
      isMobile={isMobile}
      data={data}
      labels={LABEL_LIST}
      $active={data[0].selected}
      currencyCode={currencyCode}
    />
  );
};

const StyledMultiToggleFilterGroup = styled(MultiToggleFilterGroup)<{
  $active: boolean;
}>`
  ${components.IconContainer} {
    padding: 5px;
  }

  ${components.PinComponent} {
    ${({ $active }) =>
      $active &&
      css`
        background: linear-gradient(180deg, #2080f1 0%, #5bc9f5 100%);
        box-shadow: 0px 0px 20px #00a6e3;

        ${components.IconContainer} {
          path {
            fill: white;
            stroke: white;
          }
        }
      `}
  }
`;

const StyledToggleIcon = styled(InstantConfirmFlat)`
  path {
    fill: none;
    stroke: ${({ theme }) => theme.colors.frenchGray};
  }
`;

const StyledLabelIcon = styled(InstantConfirmFlat)`
  width: 11px;
  margin-left: 5px;
  stroke: white;
  vertical-align: middle;
`;

export default Object.assign(FilterConfirmability, {
  filterName: 'confirmability',
  filterLabel: FILTER_LABEL,
  valuesLabel: (data) => {
    const selectedId = data.find((item) => item.selected)?.id;
    return selectedId ? FILTER_NAMES[selectedId] : undefined;
  },
});
